import React, { type PropsWithChildren } from 'react';
import type { TargetType } from '@atlassiansox/cross-flow-base-types';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';

interface OnboardingContainerComponentProps {
	targetProduct: TargetType;
	sourceComponent: string;
	ariaLabel: string;
}

const containerStyles = cssMap({
	root: {
		width: '932px',
		height: '500px',
	},
});

export const CreateFormOnboardingContainer = ({
	children,
	targetProduct,
	sourceComponent,
	ariaLabel,
}: PropsWithChildren<OnboardingContainerComponentProps>): React.JSX.Element => {
	return (
		<ContextualAnalyticsData
			sourceName={sourceComponent}
			sourceType={SCREEN}
			attributes={{ targetProduct }}
		>
			<FireScreenAnalytics />
			<Box
				xcss={containerStyles.root}
				aria-label={ariaLabel}
				role="main"
				testId="cross-flow-onboarding-modal.common.ui.create-form-container"
			>
				{children}
			</Box>
		</ContextualAnalyticsData>
	);
};
